var _rect, _circle, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoCardDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 20",
    width: 32,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 20,
    rx: 3,
    fill: "#fff",
    stroke: "#E6E6E6",
    strokeWidth: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 11.5,
    r: 4,
    fill: "#FF6000"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 13,
    y: 12.5,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 5,
    fontWeight: 700,
    fill: "#1A1A1A",
    textAnchor: "middle",
    letterSpacing: 0.2
  }, "DISCOVER")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCardDiscover);
export default __webpack_public_path__ + "static/media/logo-card-discover.674a3aac6a340cad0ec88d8fb9b6b74e.svg";
export { ForwardRef as ReactComponent };